import { createFeatureSelector } from 'modules/store'

import { isPresent } from '../../../app/shared'
import * as fromMultiselect from './multiselect-adapter.actions'
import { MultiselectData } from './types'

export type State = Record<string, MultiselectData>

export const STORE_ID = 'multiselect'
export const initialState: State = {}

export const reducer = (state = initialState, action: fromMultiselect.default): State => {
  switch (action.type) {
    case fromMultiselect.GET_MULTISELECT_DATA: {
      const { storeId } = action.payload

      return {
        ...state,
        [storeId]: {
          data: [],
          isLoading: true,
        },
      }
    }

    case fromMultiselect.GET_MULTISELECT_DATA_SUCCESS: {
      const { storeId, data } = action.payload
      const newSubstate = {
        [storeId]: {
          isLoading: false,
          data,
        } as MultiselectData,
      }

      return {
        ...state,
        ...newSubstate,
      }
    }

    case fromMultiselect.CLEAN_MULTISELECT_DATA: {
      const storeId = action.payload
      const newState = Object.keys(state).reduce((acc, substoreId) => {
        if (substoreId === storeId) {
          return acc
        }

        return {
          ...acc,
          [substoreId]: state[substoreId],
        }
      }, {})

      return newState
    }

    default:
      return state
  }
}

export const getMultiselectData = <T>(state: State, storeId: string, normalizeFn: (data: any[]) => T) =>
  normalizeFn(getMultiselectStore(state[storeId]).data)

export const getMultiselectLoading = (state: State, storeId: string) => getMultiselectStore(state[storeId]).isLoading

export const selectMultiselectState = createFeatureSelector<State>(STORE_ID)

function getMultiselectStore(multiselectData: MultiselectData): MultiselectData {
  if (isPresent(multiselectData)) {
    if (!isPresent(multiselectData.data)) {
      return {
        ...multiselectData,
        data: [],
      }
    }

    if (!isPresent(multiselectData.isLoading)) {
      return {
        ...multiselectData,
        isLoading: false,
      }
    }

    return multiselectData
  }

  return {
    isLoading: false,
    data: [],
  }
}



// WEBPACK FOOTER //
// ./src/modules/forms/multiselect-adapter/multiselect-adapter.reducer.ts